import React from 'react';
import { ArrowUpRight } from 'lucide-react';

const ScanToCadHero = ({ subtitle, title, description, buttonText }) => {
  return (
    <section className="scan-tocad-hero">
      <div className="hero-content">
        <p className="hero-subtitle">
          {subtitle || "Scan to CAD Services USA"}
        </p>

        <h1>
          {title || (
            <><span className="text-primary">Accurate Scan to</span> CAD Services for USA <br /> Projects</>
          )}
        </h1>

        <p className="service-description">
          {description || "Convert point cloud and laser scan data into precise CAD drawings for architecture, engineering, construction, renovation, and facility documentation projects. We deliver clean, editable drawings in DWG and PDF formats with fast turnaround."}
        </p>

        <button className="hero-btn">
          {buttonText || "Request a Quote"} <ArrowUpRight size={20} />
        </button>
      </div>
    </section>
  );
};

export default ScanToCadHero;
